var _rect, _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect2, _rect3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenericError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 140,
    viewBox: "0 0 138 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.5195,
    y: 125.966,
    width: 47.3033,
    height: 14,
    rx: 7,
    fill: "var(--primary-text-color, #313639)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2851_60417",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4315 84.121C90.4315 108.852 70.3829 128.901 45.6518 128.901C20.9206 128.901 0.87207 108.852 0.87207 84.121C0.87207 59.3899 20.9206 39.3413 45.6518 39.3413C70.3829 39.3413 90.4315 59.3899 90.4315 84.121Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.4315 84.121C90.4315 108.852 70.3829 128.901 45.6518 128.901C20.9206 128.901 0.87207 108.852 0.87207 84.121C0.87207 59.3899 20.9206 39.3413 45.6518 39.3413C70.3829 39.3413 90.4315 59.3899 90.4315 84.121Z",
    fill: "var(--error-color, #F44336)",
    fillOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4315 84.121C87.4315 107.195 68.7261 125.901 45.6518 125.901V131.901C72.0398 131.901 93.4315 110.509 93.4315 84.121H87.4315ZM45.6518 125.901C22.5775 125.901 3.87207 107.195 3.87207 84.121H-2.12793C-2.12793 110.509 19.2638 131.901 45.6518 131.901V125.901ZM3.87207 84.121C3.87207 61.0467 22.5775 42.3413 45.6518 42.3413V36.3413C19.2638 36.3413 -2.12793 57.733 -2.12793 84.121H3.87207ZM45.6518 42.3413C68.7261 42.3413 87.4315 61.0467 87.4315 84.121H93.4315C93.4315 57.733 72.0398 36.3413 45.6518 36.3413V42.3413Z",
    fill: "var(--primary-text-color, #313639)",
    mask: "url(#path-2-inside-1_2851_60417)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M113.12 78.6512C115.831 78.6512 118.029 76.4453 118.029 73.7241C118.029 71.0028 115.831 68.7969 113.12 68.7969C110.409 68.7969 108.211 71.0028 108.211 73.7241C108.211 76.4453 110.409 78.6512 113.12 78.6512Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M98.3929 87.2744C98.5543 87.2738 98.7141 87.3052 98.8633 87.3669C99.0125 87.4285 99.148 87.5192 99.2621 87.6338C99.3762 87.7483 99.4666 87.8843 99.528 88.0341C99.5895 88.1838 99.6208 88.3443 99.6201 88.5062C99.6208 88.6682 99.5895 88.8286 99.528 88.9784C99.4666 89.1281 99.3762 89.2642 99.2621 89.3787C99.148 89.4932 99.0125 89.5839 98.8633 89.6456C98.7141 89.7073 98.5543 89.7387 98.3929 89.738C98.0675 89.738 97.7553 89.6082 97.5252 89.3772C97.2951 89.1462 97.1658 88.8329 97.1658 88.5062C97.1658 88.1795 97.2951 87.8662 97.5252 87.6352C97.7553 87.4042 98.0675 87.2744 98.3929 87.2744Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91.0305 57.4641C93.6565 60.0271 97.1854 61.4439 100.848 61.4059C103.33 61.2376 105.737 60.4798 107.871 59.1948C110.004 57.9099 111.803 56.1346 113.119 54.0151C147.48 54.0151 144.402 4.74328 112.629 4.74328C109.481 4.69996 106.361 5.33767 103.481 6.61301C100.602 7.88835 98.0291 9.7714 95.9392 12.1341C93.1457 10.7593 90.0958 9.98855 86.9868 9.87164C83.8779 9.75473 80.7791 10.2943 77.891 11.4554C75.0029 12.6165 72.3897 14.3732 70.2207 16.612C68.0517 18.8508 66.3751 21.5217 65.2993 24.452",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.614 75.8397C114.325 75.8397 116.523 73.6337 116.523 70.9125C116.523 68.1913 114.325 65.9854 111.614 65.9854C108.903 65.9854 106.706 68.1913 106.706 70.9125C106.706 73.6337 108.903 75.8397 111.614 75.8397Z",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8871 84.4629C97.0484 84.4622 97.2083 84.4937 97.3575 84.5553C97.5066 84.617 97.6422 84.7077 97.7563 84.8222C97.8703 84.9367 97.9607 85.0728 98.0222 85.2225C98.0836 85.3723 98.1149 85.5328 98.1142 85.6947C98.1149 85.8566 98.0836 86.0171 98.0222 86.1669C97.9607 86.3166 97.8703 86.4527 97.7563 86.5672C97.6422 86.6817 97.5066 86.7724 97.3575 86.8341C97.2083 86.8957 97.0484 86.9271 96.8871 86.9265C96.5616 86.9265 96.2495 86.7967 96.0193 86.5657C95.7892 86.3347 95.6599 86.0214 95.6599 85.6947C95.6599 85.368 95.7892 85.0547 96.0193 84.8237C96.2495 84.5927 96.5616 84.4629 96.8871 84.4629Z",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5247 54.6526C92.1506 57.2155 95.6795 58.6324 99.342 58.5944C101.824 58.4261 104.232 57.6682 106.365 56.3833C108.499 55.0984 110.297 53.323 111.614 51.2036C145.974 51.2036 142.897 1.93176 111.123 1.93176C107.975 1.88844 104.856 2.52614 101.976 3.80149C99.0957 5.07683 96.5233 6.95988 94.4333 9.32253C91.6398 7.94779 88.59 7.17703 85.481 7.06012C82.372 6.94321 79.2732 7.48276 76.3851 8.64385C73.497 9.80494 70.8839 11.5617 68.7149 13.8005C66.5458 16.0393 64.8692 18.7102 63.7935 21.6405",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1788 61.6085C69.1982 58.1309 74.0078 65.9986 74.4714 67.5881",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3587 89.0925C54.1245 88.3067 51.4563 90.5826 51.213 91.1852",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.654 56.1417C32.6346 52.6641 27.825 60.5318 27.3614 62.1213",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8895 71.1968C37.0567 71.1968 37.2202 71.2464 37.3592 71.3393C37.4983 71.4322 37.6067 71.5642 37.6707 71.7187C37.7346 71.8732 37.7514 72.0432 37.7188 72.2073C37.6861 72.3713 37.6056 72.5219 37.4874 72.6402C37.3691 72.7584 37.2185 72.839 37.0544 72.8716C36.8904 72.9042 36.7204 72.8875 36.5659 72.8235C36.4114 72.7595 36.2794 72.6511 36.1864 72.5121C36.0935 72.373 36.0439 72.2095 36.0439 72.0423C36.0439 71.8181 36.133 71.603 36.2916 71.4444C36.4502 71.2859 36.6652 71.1968 36.8895 71.1968Z",
    fill: "var(--primary-text-color, #313639)",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6602 71.1968C65.8275 71.1968 65.9909 71.2464 66.13 71.3393C66.269 71.4322 66.3774 71.5642 66.4414 71.7187C66.5054 71.8732 66.5221 72.0432 66.4895 72.2073C66.4569 72.3713 66.3764 72.5219 66.2581 72.6402C66.1399 72.7584 65.9892 72.839 65.8252 72.8716C65.6612 72.9042 65.4912 72.8875 65.3367 72.8235C65.1822 72.7595 65.0501 72.6511 64.9572 72.5121C64.8643 72.373 64.8147 72.2095 64.8147 72.0423C64.8147 71.8181 64.9038 71.603 65.0623 71.4444C65.2209 71.2859 65.436 71.1968 65.6602 71.1968Z",
    fill: "var(--primary-text-color, #313639)",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8483 111.011L50.4014 105.157L55.9132 104.331C56.4559 104.301 56.9644 104.056 57.3269 103.651C57.6894 103.246 57.8762 102.714 57.8461 102.171C57.8161 101.628 57.5716 101.12 57.1666 100.757C56.7616 100.395 56.2292 100.208 55.6864 100.238L39.8472 100.755C39.8472 100.755 40.6716 92.2619 37.9056 92.2618C35.1396 92.2618 35.1654 95.4093 34.0953 100.831L23.4869 109.67",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5762,
    y: 77.3726,
    width: 14.2617,
    height: 12.0315,
    rx: 6.01576,
    fill: "white",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68.8228,
    y: 77.3726,
    width: 14.2617,
    height: 12.0315,
    rx: 6.01576,
    fill: "white",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(88, 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5358 19.1421C14.5648 18.1709 14.0194 16.8538 14.0195 15.4804C14.0197 14.1071 14.5653 12.79 15.5365 11.819C16.5077 10.848 17.8249 10.3026 19.1982 10.3027C20.5716 10.3029 21.8886 10.8485 22.8596 11.8197L29.4506 18.4177C29.932 18.8983 30.3139 19.4691 30.5745 20.0974C30.835 20.7258 30.9692 21.3993 30.9692 22.0796C30.9692 22.7598 30.835 23.4334 30.5745 24.0617C30.3139 24.6901 29.932 25.2609 29.4506 25.7415L26.5138 22.8047C25.5013 21.9151 24.1997 21.4244 22.8519 21.4244C21.5041 21.4244 20.2025 21.9151 19.19 22.8047L15.5358 19.1421Z",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6052 1.56689L16.267 5.22866L8.94346 12.5522L5.2817 8.89042L12.6052 1.56689Z",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8027 6.69287L18.4653 10.3541",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4089 11.0869L14.0701 14.7481",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3833 17.3662L3.18444 28.5693C2.70227 29.0515 2.4314 29.7054 2.4314 30.3873C2.4314 31.0692 2.70227 31.7232 3.18444 32.2053C3.6666 32.6875 4.32056 32.9584 5.00244 32.9584C5.68433 32.9584 6.33828 32.6875 6.82045 32.2053L17.7103 21.3141",
    stroke: "var(--error-color, #F44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericError);
export default __webpack_public_path__ + "static/media/generic_error.3ae7ea2c.svg";
export { ForwardRef as ReactComponent };